import React from 'react';
import {
  Typography,
  Stack,
  Divider,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const PaymentTermsTable = ({ paymentTerms, pricing }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const gstAmount = (pricing?.installationCost * pricing?.gst) / 100;
  const payableAmount = (pricing?.installationCost + gstAmount).toFixed(2);
  const netCost =
    payableAmount -
    (pricing?.applicableStateSubsidy || 0) -
    (pricing?.applicableCentralSubsidy || 0);
  const netCostPerKw = pricing?.plantSize
    ? (netCost / pricing?.plantSize).toFixed(2)
    : 0;

  const termsData = [
    {
      milestone: 'Order confirmation',
      percentage: paymentTerms?.orderConfirmation,
      amount: Math.floor(
        (payableAmount * paymentTerms?.orderConfirmation) / 100,
      ).toLocaleString('en-IN'),
      paymentDetails: 'Paid on 23 Dec',
    },
    {
      milestone: 'Before material dispatch',
      percentage: paymentTerms?.beforeMaterialDispatch,
      amount: Math.floor(
        (payableAmount * paymentTerms?.beforeMaterialDispatch) / 100,
      ).toLocaleString('en-IN'),
      paymentDetails: 'Pay with UPI',
    },
    {
      milestone: 'Before installation begins',
      percentage: paymentTerms?.beforeInstallationBegins,
      amount: Math.floor(
        (payableAmount * paymentTerms?.beforeInstallationBegins) / 100,
      ).toLocaleString('en-IN'),
      paymentDetails: 'Due on 23 days',
    },
    {
      milestone: 'After commissioning',
      percentage: paymentTerms?.afterCommissioning,
      amount: Math.floor(
        (payableAmount * paymentTerms?.afterCommissioning) / 100,
      ).toLocaleString('en-IN'),
      paymentDetails: 'Due on 29 days',
    },
  ];

  return (
    <Stack
      spacing={3}
      alignItems='flex-start'
      width={isMobile ? '100%' : '32rem'}
    >
      <Typography variant='h5' fontWeight={600}>
        Pricing
      </Typography>
      <Box mt={2} width={'100%'}>
        <Stack spacing={1}>
          <Stack direction='row' justifyContent='space-between'>
            <Typography variant='body1'>Installation cost</Typography>
            <Typography variant='body1'>
              ₹{pricing?.installationCost?.toLocaleString('en-IN')}
            </Typography>
          </Stack>

          <Stack direction='row' justifyContent='space-between'>
            <Typography variant='body1'>
              Goods and services tax (GST) @ {pricing?.gst}%
            </Typography>
            <Typography variant='body1'>
              ₹{Math.floor(gstAmount).toLocaleString('en-IN')}
            </Typography>
          </Stack>
          <Divider sx={{ my: 1, borderBottomWidth: 2 }} />
          <Stack direction='row' justifyContent='space-between'>
            <Typography variant='h6'>
              <strong>Payable amount </strong>
            </Typography>
            <Typography variant='h6'>
              <strong>
                ₹{Math.floor(payableAmount).toLocaleString('en-IN')}
              </strong>
            </Typography>
          </Stack>
        </Stack>
      </Box>

      {/* Payment Terms List */}
      <Box width={'100%'}>
        <Typography variant='h6' fontWeight={600} mb={2} mt={2}>
          Payment milestone
        </Typography>
        {termsData.map((term, index) => (
          <Stack
            key={index}
            direction='row'
            spacing={1}
            mb={1}
            justifyContent='space-between'
          >
            <Stack direction='row' spacing={1} alignItems='center'>
              {/* {term.icon} */}
              <Typography>{term.milestone}</Typography>
            </Stack>
            <Typography>
              ₹{term.amount.toLocaleString('en-IN')} ({term.percentage}%)
            </Typography>
          </Stack>
        ))}
        <Divider sx={{ width: '100%' }} />
        <Stack
          pt={1}
          width={'100%'}
          direction={'row'}
          justifyContent={'space-between'}
        >
          <Typography variant='body1'>Total cost</Typography>
          <Typography variant='h6' fontWeight={600}>
            ₹{Math.floor(payableAmount)?.toLocaleString('en-IN')}
          </Typography>
        </Stack>
      </Box>

      {/* Government Subsidies Section */}
      <Box width={'100%'}>
        <Typography variant='h6' mt={2} mb={2} fontWeight={600}>
          Subsidies
        </Typography>
        <Stack spacing={1}>
          <Stack direction='row' justifyContent='space-between'>
            <Typography variant='body1'>Central govt subsidy</Typography>
            <Typography variant='body1'>
              ₹{pricing?.applicableCentralSubsidy?.toLocaleString('en-IN')}
            </Typography>
          </Stack>
          <Stack direction='row' justifyContent='space-between'>
            <Typography variant='body1'>State govt subsidy</Typography>
            <Typography variant='body1'>
              ₹{pricing?.applicableStateSubsidy?.toLocaleString('en-IN')}
            </Typography>
          </Stack>
        </Stack>
        <Divider sx={{ my: 1, borderBottomWidth: 2 }} />
        <Stack spacing={1}>
          <Stack direction='row' justifyContent='space-between'>
            <Typography variant='h6'>
              <strong>Net cost after subsidies</strong>
            </Typography>
            <Typography variant='h6' fontWeight={600}>
              ₹{Math.floor(netCost)?.toLocaleString('en-IN')}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};

export default PaymentTermsTable;
